import ToastStatusGlobal from '@/components/toastStatusGlobal';
import { useCompanyPropagate } from '@/modules/company/hooks/useCompanyPropagate';
import useLoadCompany from '@/modules/company/hooks/useLoadCompany/useLoadCompany';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import { useHistoryParams } from '@/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useCompanyWhenLoadPage = () => {
  const routeParamsRef = useRef(useHistoryParams());
  const { loadCompany } = useLoadCompany();
  const { propagateCompany } = useCompanyPropagate();
  const { isCompanyUser, userCompanies } = useCurrentUser();
  const { toast } = ToastStatusGlobal();
  const [loading, setLoading] = useState(true);

  const loadAndPropagateCompany = useCallback(
    async (companyIdToLoad: string) => {
      try {
        if (!companyIdToLoad) {
          return;
        }

        const loadedCompany = isCompanyUser
          ? userCompanies?.find((company) => company.id === companyIdToLoad)
          : await loadCompany(companyIdToLoad);

        if (!loadedCompany) {
          return;
        }

        await propagateCompany(loadedCompany);
      } catch (e) {
        console.warn(e);
        toast('Oops', 'Falha no carregar empresa.', 'error');
      } finally {
        setLoading(false);
      }
    },
    [isCompanyUser, loadCompany, propagateCompany, toast, userCompanies],
  );

  useEffect(() => {
    if (!routeParamsRef.current.companyId) {
      setLoading(false);
      return;
    }
    loadAndPropagateCompany(routeParamsRef.current.companyId);
  }, [loadAndPropagateCompany]);

  useEffect(() => {
    window.addEventListener('modal-login', () => setLoading(false));

    return () => {
      window.removeEventListener('modal-login', () => setLoading(false));
    };
  }, []);

  return {
    loading,
  };
};
